import axios from 'axios';
import * as React from 'react';
import { requestDeleteApPlanAction } from '../asyncHelpers/actionPlanService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncDeleteApPlanAction
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestDeleteApPlanAction HTTP request
 */
export default function useAsyncDeleteApPlanAction() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncDeleteApPlanAction = async (
        planId: number,
        actionId: number,
    ): Promise<boolean | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            await requestDeleteApPlanAction(planId, actionId, request_token.token);

            setRequestStatus(RequestStatus.success);

            return true;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while deleting plan action');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncDeleteApPlanAction,
    };
}
